import React, { useEffect } from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import GlobalStyles from '@iso/assets/styles/globalStyle';
import { store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'draft-js/dist/Draft.css';
// import '@draft-js-plugins/linkify/lib/plugin.css';
import Routes from './router';
import { GlobalModalProvider } from './components/GlobalModal/GlobalModalContext';
import Loader from '@iso/components/utility/loader';
import { startAppRequest } from '@iso/redux/auth/actions';
import { GoogleOAuthProvider } from '@react-oauth/google';
import DefaultSEO from './components/DefaultSEO';

const App = () => {
  const { app } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const clientID = (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') ? 
    '179585559690-le69529jbmg9uhbj42vqjqedp2pbibd6.apps.googleusercontent.com' : 
    '1010501654593-pfikifshg1ql3ms36rt45vm2fq79hvda.apps.googleusercontent.com';

  useEffect(() => {
    dispatch(startAppRequest());
  }, []);

  if (app.loading || !app.appCanStart) return <Loader />;

  return (
    <GlobalModalProvider>
      <GoogleOAuthProvider clientId={clientID} redirectUri={window.location.origin}>
        <ToastContainer
          position={'bottom-right'}
          autoClose={3000}
          hideProgressBar={true}
          pauseOnFocusLoss={false}
        />
        <DefaultSEO />
        <Routes />
      </GoogleOAuthProvider>
    </GlobalModalProvider>
  );
};

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <GlobalStyles />
        <App />
      </HelmetProvider>
    </Provider>
  );
};

export default AppWrapper;
